const handleDeleteMaintenanceModal = {
  text1: 'Deseja realmente deletar essa Manutenção?',
  text2: 'APAGAR MANUTENÇÃO',
};

export default handleDeleteMaintenanceModal;
